<!-- 首页//成本目标  -->
<template>
  <div class="box">
    <Title :text="home.CostTarget.Title[0]" :engText="home.CostTarget.Title[1]"></Title>
	<div class="content">
		<div class="content-title">
		  <div class="a">
		    [
		    <div :class="`${active === 1 ? 'active' : ''}`" @click="fn1(1)">本日</div>
		    <div :class="`${active === 2 ? 'active' : ''}`" @click="fn1(2)">本月</div>
		    <div :class="`${active === 3 ? 'active' : ''}`" @click="fn1(3)">本年</div>
		    ]
		  </div>
		</div>
		<div class="mass">
			<div class="a a1">
				<div class="icon1"></div>
				<div class="text-box">
					<div>
						<span class="a1">实际用能：</span>
						<span class="a2">1000</span>
						<span class="t">kwh</span>
					</div>
					<div>
						<span class="a1">目标用能：</span>
						<span class="a2">1000</span>
						<span class="t">kwh</span>
					</div>
					<div>
						<div class="scale">同比</div>
						<div>
							<span class="white scale">100%</span>
							<span class="add"></span>
						</div>
					</div>
					<div>
						<div class="scale">环比</div>
						<div>
							<span class="white scale">100%</span>
							<span class="reduce"></span>
						</div>
					</div>
				</div>
			</div>
			<div class="a a2">
				<div class="icon2"></div>
				<div class="text-box">
					<div>
						<span class="a1">实际用能：</span>
						<span class="a2">1000</span>
						<span class="t">kwh</span>
					</div>
					<div>
						<span class="a1">目标用能：</span>
						<span class="a2">1000</span>
						<span class="t">kwh</span>
					</div>
					<div>
						<div class="scale">同比</div>
						<div>
							<span class="white scale">100%</span>
							<span class="add"></span>
						</div>
					</div>
					<div>
						<div class="scale">环比</div>
						<div>
							<span class="white scale">100%</span>
							<span class="reduce"></span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
import Title from '../../components/title/index.vue';
import { mapState,mapActions } from 'pinia' //引入映射函数
import useStore from '@/store/index' //引入store
export default {
  components: {
    Title,
  },
  computed:{
    ...mapState(useStore,['home']) 
  },
  data () {
    return {
      // active 1:日，2:月，3:年
      active:1,
    }
  },
  mounted () {
	  
  },
  methods: {
    fn1(i){
      this.active = i;
    }
  }
}
</script>

<style scoped>
.box{
   width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.content{
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.content-title{
  width: 100%;
  height: 30px;
  display: flex;
  flex-direction: column;
}
.content-title .a{
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-title .a > div{
  margin: 0px 10px;
  font-size: 12px;
  cursor: pointer;
}
.mass {
	flex: 1;
	display: flex;
	justify-content: space-between;
	margin-top: 20px;
}
.mass .a{
	width: 135px;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}
.mass .a .icon1{
	width: 92px;
	height: 90px;
	background: url('../../assets/img/电icon.png') no-repeat;
	background-size: 100% 100%;
}
.mass .a .icon2{
	width: 92px;
	height: 90px;
	background: url('../../assets/img/水icon.png') no-repeat;
	background-size: 100% 100%;
}
.mass .a .text-box{
	width: 100%;
	flex: 1;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
}
.mass .a .text-box span{
	font-size: 12px;
}
.mass .a .text-box .a1{
	font-size: 14px;
}
.mass .a .text-box .a2{
	font-size: 14px;
	color: white;
}
.mass .a .text-box .t{
	display: inline-block;
	margin-left: 1px;
}
.mass .a .text-box >div:nth-child(3),
.mass .a .text-box >div:nth-child(4){
	display: flex;
	font-size: 12px;
	justify-content: space-between;
}
.white{
	color: white;
}
.active{
  text-shadow: 0px 4px 5px #488dff;
}
</style>